import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { fetchArticles } from "@/lib/api";

export default function SignalLibraryPage() {
  const [articles, setArticles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0 });
    fetchArticles().then(setArticles).catch(() => setArticles([]));
  }, []);

  return (
    <div data-testid="signal-library-page">
      <Navigation />
      <main className="pt-28 pb-24 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            data-testid="signal-back"
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-sm text-axiom-muted hover:text-axiom-text transition-colors mb-10"
          >
            <ArrowLeft size={14} /> Back to home
          </button>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
            <div className="lg:col-span-7">
              <div className="flex items-center gap-2 mb-5">
                <span className="num-label">SIGNAL LIBRARY · ARCHIVE</span>
                <div className="flex-1 h-px bg-white/10" />
              </div>
              <h1 className="font-display font-bold text-axiom-text tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
                Field Intelligence <br />
                <span className="text-axiom-muted">for Operators.</span>
              </h1>
            </div>
            <div className="lg:col-span-5">
              <p className="text-axiom-muted text-base sm:text-lg leading-relaxed">
                The Signal Library is Axiom-AI's archive of operating-grade
                analysis on dwell, empty miles, forecasting, EDI visibility,
                AI in logistics, and the operating decisions that produce
                cost long before finance sees it.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {articles.map((a) => (
              <button
                key={a.slug}
                data-testid={`archive-article-${a.slug}`}
                onClick={() => navigate(`/signal-library/${a.slug}`)}
                className="bg-axiom-bg text-left p-6 md:p-8 hover:bg-axiom-surface transition-colors group min-h-[280px] flex flex-col"
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="num-label text-axiom-accent">
                    {a.eyebrow}
                  </span>
                  <ArrowUpRight
                    size={16}
                    className="text-axiom-muted group-hover:text-axiom-accent group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all"
                  />
                </div>
                <h3 className="font-display text-xl text-axiom-text font-bold leading-snug">
                  {a.title}
                </h3>
                <p className="mt-3 text-sm text-axiom-muted leading-relaxed">
                  {a.excerpt}
                </p>
                <div className="mt-auto pt-6 flex items-center gap-3">
                  <div className="h-px flex-1 bg-white/10" />
                  <span className="num-label">{a.read_time}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
